var KEY={
LIFECYCLE:'redux-pack/LIFECYCLE',
TRANSACTION:'redux-pack/TRANSACTION'};


var LIFECYCLE={
START:'start',
SUCCESS:'success',
FAILURE:'failure'};


module.exports={
KEY:KEY,
LIFECYCLE:LIFECYCLE};


//////////////////
// WEBPACK FOOTER
// ./~/redux-pack/lib/constants.js
// module id = 109
// module chunks = 10